/* @flow */
import { dispatcher } from 'lib/Dispatcher';
import Offline from 'lib/Offline';

import { ActionTypes } from '../constants/AppConstants';

let _observingConnection = false;

const AppActions = {
  observeConnection() {
    if (_observingConnection) {
      return;
    }

    let previous = 'connected';
    const onStateChange = function(current) {
      if (__DEV__) {
        console.log('Connection state changed:', current);
      }
      dispatcher.dispatch({
        type: ActionTypes.CONNECTION_STATE_CHANGED,
        previous,
        current,
      });
      previous = current;
    };

    if (__DEV__) {
      window.offline = () => onStateChange('unavailable');
      window.online = () => onStateChange('connected');
    }

    Offline.on('down', () => onStateChange('unavailable'));
    Offline.on('reconnect:connecting', () => onStateChange('connecting'));
    Offline.on('up', () => onStateChange('connected'));

    _observingConnection = true;
  },
};

export default AppActions;
